import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl  } from "@angular/platform-browser";

export interface EmailPreviewData {
    email: {
        html: string;
        text: string;
        subject: string;
    }
}

@Component({
    selector: 'eas-email-preview',
    templateUrl: 'email-preview.component.html',
    providers: [],
    standalone: false
})
export class EmailPreviewComponent {
    href: string | undefined;
    safeUrl: SafeResourceUrl | undefined;

    constructor(
        public dialogRef: MatDialogRef<EmailPreviewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EmailPreviewData,
        private sanitizer: DomSanitizer,
    ) {

    }

    ngOnInit() {
        this.showHtml(this.data.email.html);
    }

    private showHtml(html: string) {
        var blob = new Blob([html], { type: 'text/html' });
        if (this.href) {
          window.URL.revokeObjectURL(this.href);
        }

        this.href = window.URL.createObjectURL(blob);
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.href);
    };

}